import styled from 'styled-components';

export const AvatarImage = styled.img`
    border-radius: 50%;
    height: 100%;
    width: 100%;
    object-fit: contain;
    user-select: none;
    -webkit-user-drag: none;
`;
